import React from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { Dropdown } from "react-bootstrap";
import { BtnTraNhanVay } from "./ChucNang/TraNhanVay/BtnTraNhanVay";
import { BtnTraBotGoc } from "./ChucNang/TraBotGoc/BtnTraBotGoc";
import { BtnGiaHan } from "./ChucNang/GiaHanHopDong/BtnGiaHan";
import { BtnGiaHanNgayTra } from "./ChucNang/GiaHanNgayTra/BtnGiaHanNgayTra";
import { BtnGhiChu } from "./ChucNang/BtnGhiChu";
import { BtnSua } from "./ChucNang/BtnSua";
import { getDate } from "utils/formatDate";
import { catChuoi } from "utils/stringExtension";
import { useSelector } from "react-redux";
import { formatNumber } from "utils/currencyFormat";
import { DSNhanVayConst } from "../../constants/nhanVayConst";
import { BtnXoa } from "./ChucNang/Xoa/BtnXoa";
import { BtnChiTietHopDong } from "./ChiTietHopDong/BtnChiTietHopDong";
import { BtnChiTietKhachHang } from "./ChiTietKhachHang/BtnChiTietKhachHang";
import { BtnVayThem } from "./ChucNang/VayThem/BtnVayThem";
export const ContentTable = ({
  listdata,
  quyenGhiChu,
  quyenGiaHanHopDong,
  quyenGiaHanNgayTra,
  quyenSuaNhanVay,
  quyenTatToan,
  quyenXemChiTietHopDong,
  quyenXemChiTietKhachHang,
  quyenTraBotGoc,
  quyenVayThem,
  quyenTralai,
  quyenXoa,
  quyenSuaTienTatToan,
  choVay,
  setChoVay,
  objThietLapHienThiDanhSach,
  printThuChi,
  handleShowTraLai,
}) => {
  //active khi chọn 1 dòng table

  const selectRow = (item) => () => {
    setChoVay(item);
  };
  let isShow = false;
  if (matchMedia) {
    var mq = window.matchMedia("(max-width: 768px)");
    isShow = mq.matches;
  }

  //End-active khi chọn 1 dòng table
  const dataSearch = useSelector((state) => state.dataSearchNhanVay);
  return listdata.map((item, index) => (
    <div
      className={
        "custom-table-row " + (item === choVay && !isShow ? "active" : "")
      }
      key={"item" + index}
      onClick={selectRow(item)}
    >
      {objThietLapHienThiDanhSach.IsAnSTT != true && (
        <div className="custom-table-cell username-cell flex-basis-5 flex-basis-6-sm disk-mobile">
          <span className="mobile-column-name">STT</span>
          <div className="center-wrapper">
            <p className="text-center">
              {index + 1 + (dataSearch.pageIndex - 1) * dataSearch.pageSize}
            </p>
          </div>
        </div>
      )}
      {objThietLapHienThiDanhSach.IsAnMaHD != true && (
        <div className="custom-table-cell flex-basis-14 flex-basis-15-6-sm">
          <span className="mobile-column-name">Mã nhận vay</span>
          <div className="center-wrapper">
            <span className="profile_name">
              {quyenXemChiTietHopDong && <BtnChiTietHopDong item={item} />}
              {!quyenXemChiTietHopDong && (
                <a href={() => false} className="blue btn-link">
                  {item.MaNhanVay}
                </a>
              )}
              <br />
              <span className="font-lai color7">
                {getDate(item.NgayVay)}
                <br />
                {getDate(item.NgayTra)}
              </span>
            </span>
          </div>
        </div>
      )}
      {objThietLapHienThiDanhSach.IsAnTenKH != true && (
        <div className="custom-table-cell flex-basis-12 flex-basis-11-8-sm">
          <span className="mobile-column-name">Tên chủ nợ</span>
          <div className="center-wrapper">
            <p>
              {quyenXemChiTietKhachHang && <BtnChiTietKhachHang item={item} />}
              {!quyenXemChiTietKhachHang && (
                <a href={() => false} className="blue btn-link">
                  {item.TenChuNo}
                </a>
              )}
              <br />
              {item.SoDienThoai}
            </p>
          </div>
        </div>
      )}
      {objThietLapHienThiDanhSach.IsAnTSTheChap != true && (
        <div className="custom-table-cell flex-basis-10 flex-basis-9-sm">
          <span className="mobile-column-name">TS thế chấp</span>
          <div className="center-wrapper">
            <p className="text-left" title={item.TaiSanTheChap}>
              {catChuoi(item.TaiSanTheChap, 10)}
            </p>
          </div>
        </div>
      )}
      {objThietLapHienThiDanhSach.IsAnSoTienVay != true && (
        <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
          <span className="mobile-column-name">Số tiền vay</span>
          <div className="center-wrapper">
            <p className="text-right">
              <span className="fontnew-500 color-do-bold">
                {formatNumber(item.SoTienVay)}
              </span>{" "}
              <br />{" "}
              <span className="font-lai">(Lãi suất: {item.LaiSuat})</span>
            </p>
          </div>
        </div>
      )}
      {objThietLapHienThiDanhSach.IsAnLaiPhaiTra != true && (
        <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
          <span className="mobile-column-name">Lãi phải trả</span>
          <div className="center-wrapper">
            <p className="text-right">
              <span className="fontnew-500 color7-bold">
                {formatNumber(item.LaiPhaiTra)}
              </span>
              <br />
              <span className="font-lai">({item.Ky} kỳ)</span>
            </p>
          </div>
        </div>
      )}
      {objThietLapHienThiDanhSach.IsAnLaiDenHomNay != true && (
        <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
          <span className="mobile-column-name">Lãi đến hôm nay</span>
          <div className="center-wrapper">
            <p className="text-right">
              <span className="fontnew-500 color7-bold">
                {formatNumber(item.LaiDenHomNay)}
              </span>
              <br />
              <span className="font-lai">({item.SoNgayConNo} ngày)</span>
            </p>
          </div>
        </div>
      )}
      {objThietLapHienThiDanhSach.IsAnTienDaTra != true && (
        <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
          <span className="mobile-column-name">Tiền đã trả</span>
          <div className="center-wrapper">
            <p className="text-right">
              <span className="center-wrapper color-xanh-bold blue">
                {formatNumber(item.TienDaTra)}
              </span>
            </p>
          </div>
        </div>
      )}
      {objThietLapHienThiDanhSach.IsAnTrangThai != true && (
        <div className="custom-table-cell flex-basis-8 flex-basis-12-sm action-cell">
          <span className="mobile-column-name">Trạng thái</span>
          <div className="center-wrapper">
            <p className="text-center">
              <span
                className={
                  item.TrangThaiID === DSNhanVayConst.TinhTrangNhanVay.DangVay
                    ? "dang-vay"
                    : item.TrangThaiID === DSNhanVayConst.TinhTrangNhanVay.DuLai
                      ? "dang-vay"
                      : item.TrangThaiID ===
                          DSNhanVayConst.TinhTrangNhanVay.NoLai
                        ? "canh-bao-no"
                        : item.TrangThaiID ===
                            DSNhanVayConst.TinhTrangNhanVay.QuaHan
                          ? "canh-bao-red"
                          : "dong"
                }
              >
                {item.TrangThai}
              </span>
            </p>
          </div>
        </div>
      )}
      {objThietLapHienThiDanhSach.IsAnChucNang != true && (
        <div className="custom-table-cell flex-basis-16 flex-basis-15-6-sm  action-cell">
          <div className="center-wrapper">
            <div className="iconTableMormanCenter">
              {item.TrangThaiID !== 2 && quyenSuaNhanVay && (
                <BtnSua NhanVayID={item.ID} />
              )}
              {item.TrangThaiID !== 2 && quyenTralai && (
                // <BtnTraLai item={item} printThuChi={printThuChi} />
                <a onClick={(e) => handleShowTraLai(item)} href={() => false}>
                  <PopoversBootrap
                    contentText="Trả lãi"
                    titleText=""
                    trigger={["hover", "focus"]}
                    placement={"top"}
                  >
                    <span className="dong-lai-button"></span>
                  </PopoversBootrap>
                </a>
              )}
              {item.TrangThaiID !== 2 && quyenTatToan && (
                <BtnTraNhanVay
                  item={item}
                  quyenSuaTienTatToan={quyenSuaTienTatToan}
                />
              )}
              {item.TrangThaiID !== 2 && quyenTraBotGoc && (
                <BtnTraBotGoc item={item} />
              )}
              {item.TrangThaiID !== 2 && quyenVayThem && (
                <BtnVayThem item={item} />
              )}

              {item.TrangThaiID !== 2 &&
                (quyenGiaHanHopDong ||
                  quyenGiaHanNgayTra ||
                  quyenGhiChu ||
                  quyenXoa) && (
                  // <Dropdown className="DropNew trangthai-new dropdown-toggle">
                  //   <Dropdown.Toggle variant="success" id="dropdown-basic">
                  //     <img
                  //       src="/app-assets/images/icon-more.png"
                  //       alt="Dropdown icon"
                  //       className="dropdown-icon"
                  //     />
                  //   </Dropdown.Toggle>
                  //   <Dropdown.Menu className="dropdown-menu arrow">
                  //     <div className="block-iconmm">
                  //       {quyenGiaHanHopDong && <BtnGiaHan item={item} />}

                  //       {quyenGiaHanNgayTra && <BtnGiaHanNgayTra item={item} />}
                  //       {quyenGhiChu && <BtnGhiChu item={item} />}
                  //       {quyenXoa && <BtnXoa item={item} />}
                  //     </div>
                  //   </Dropdown.Menu>
                  // </Dropdown>

                  <Dropdown className="DropNew trangthai-new dropdown-toggle">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <img
                        src="/app-assets/images/icon-more.png"
                        alt="Dropdown icon"
                        className="dropdown-icon"
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      className="dropdown-menu-v2 arrow"
                      style={{ borderRadius: "10px" }}
                    >
                      <div className="block-iconmm  vertical-layout">
                        {quyenGiaHanHopDong && <BtnGiaHan item={item} />}
                        {quyenGiaHanNgayTra && <BtnGiaHanNgayTra item={item} />}
                        {quyenGhiChu && <BtnGhiChu item={item} />}
                        {quyenXoa && <BtnXoa item={item} />}
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
            </div>
          </div>
        </div>
      )}
    </div>
  ));
};
